<template>
  <div
    class="page-intro section-spacing"
    :class="[
      data.imageFullWidth ? 'page-intro--img-full' : '',
      data.isShort ? 'page-intro--img-short' : '',
      bgColorClass,
      textBoxClass,
      titleClass,
    ]">
    <div class="page-intro__img-container">
      <div
        class="page-intro__img"
        :style="{ backgroundImage: 'url(' + data.image.image + ')' }"
        :class="imgClass"></div>
      <div class="page-intro__title">
        <Heading :headingTag="'h1'" :style="'h1'">
          {{ data.title }}
        </Heading>
      </div>
    </div>
    <div class="page-into__text-box">
      <div>
        <Heading
          class="page-intro__sub-title"
          :headingTag="'h2'"
          :type="'h2'"
          v-if="data.subTitle">
          {{ data.subTitle }}
        </Heading>
        <Hr class="mb-30px" />
        <div class="page-intro__body" v-if="data.body" v-html="data.body"></div>
        <div class="page-intro__button" v-if="data.button">
          <Button
            :link="data.button.url"
            :tag="data.button.buttonType"
            :style="'primary'">
            {{ data.button.buttonText }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../Atoms/Button.vue";
import Heading from "../Atoms/Heading.vue";
import Hr from "../Atoms/Hr.vue";

import { computed } from "@vue/runtime-core";
import { useCustomValidator } from "../../compostables/useValidators";

export default {
  components: {
    Button,
    Heading,
    Hr,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const titleClass = computed(() => ({
      "page-intro--right": props.data.titlePosition === "right bottom",
      "page-intro--left": props.data.titlePosition === "left bottom",
      "page-intro--right page-intro--top":
        props.data.titlePosition === "right top",
      "page-intro--left page-intro--top":
        props.data.titlePosition === "left top",
    }));

    const textBoxClass = computed(() => ({
      "page-intro--below": props.data.textboxPosition === "below",
      "page-intro--hidden": props.data.textboxPosition === "hidden",
    }));

    const bgColorClass = computed(() => ({
      "page-intro--bg-light-gray": props.data.backgroundColor === "gray",
      "page-intro--bg-dark-gray": props.data.backgroundColor === "dark gray",
      "page-intro--bg-navy": props.data.backgroundColor === "navy",
      "page-intro--bg-light-blue": props.data.backgroundColor === "blue",
    }));

    const imgClass = computed(() => ({
      "bg-top": props.data.imagePosition === "top",
      "bg-bottom": props.data.imagePosition === "bottom",
      "bg-center": props.data.imagePosition === "center",
      "bg-right": props.data.imagePosition === "right",
      "bg-right-bottom": props.data.imagePosition === "right bottom",
      "bg-right-top": props.data.imagePosition === "right top",
      "bg-left": props.data.imagePosition === "left",
      "bg-left-bottom": props.data.imagePosition === "left bottom",
      "bg-left-top": props.data.imagePosition === "left top",
    }));

    return {
      bgColorClass,
      imgClass,
      textBoxClass,
      titleClass,
    };
  },
};
</script>
